import React from 'react';

import { OverlayTrigger, Popover } from 'react-bootstrap';

import Button from '../Button';
import './styles.scoped.css';

const PopoverButton = ({
  buttonText = '',
  popoverClassName = '',
  content,
  disabled = false,
  emailAddress = '',
  icon,
  placement = 'bottom',
  popoverText = '',
  popoverVariant = 'primary',
  style = {},
  title = '',
}) => {
  const popover = (
    <Popover id="popover-help">
      {title && (
        <Popover.Title as="h3" className="popover-title">
          {title}
        </Popover.Title>
      )}
      <Popover.Content>
        {emailAddress ? (
          <a className="popover-email" href={`mailto:${process.env.REACT_APP_DQF_CONTACT_EMAIL}`}>
            Email: {emailAddress}
          </a>
        ) : (
          <div>{emailAddress}</div>
        )}
        {content && <div>{content}</div>}
      </Popover.Content>
    </Popover>
  );

  if (disabled) {
    return <Button icon={icon} style={style} text={buttonText} />;
  }

  return (
    <OverlayTrigger transition trigger="click" placement={placement} overlay={popover} rootClose>
      <Button className={popoverClassName} style={style} icon={icon} variant={popoverVariant} text={popoverText} />
    </OverlayTrigger>
  );
};

export default PopoverButton;
